// API pagination limits
export const MAX_PATIENTS_PER_PAGE = 100;

// Avatar upload limits (must match backend AvatarService limits)
export const MAX_AVATAR_SIZE_MB = 10;
export const MAX_AVATAR_SIZE_BYTES = MAX_AVATAR_SIZE_MB * 1024 * 1024;
